import LayoutNavigationHelper from './layout-navigation-helper';
import LayoutNavigation from './layout-navigation';
import LayoutNavigationLanguage from './layout-navigation-language';

window.LayoutNavigationHelper = LayoutNavigationHelper;
window.WartsilaLayoutNavigation = LayoutNavigation;
window.WartsilaLayoutNavigationLanguage = LayoutNavigationLanguage;